module.exports = __webpack_public_path__ + "img/static_stretch_splash.9ac6010f.jpg";